"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Texture_1 = require("../tree/Texture");
class SourceTexture extends Texture_1.Texture {
    constructor() {
        super(...arguments);
        this._textureSource = undefined;
    }
    get textureSource() {
        return this._textureSource;
    }
    set textureSource(v) {
        if (v !== this._textureSource) {
            if (v && v.isResultTexture) {
                // In case of a result texture, automatically inherit the pixel ratio.
                this.pixelRatio = this.stage.getPixelRatio();
            }
            this._textureSource = v;
            this._changed();
        }
    }
    _getIsValid() {
        return !!this._textureSource;
    }
}
exports.SourceTexture = SourceTexture;
//# sourceMappingURL=SourceTexture.js.map